const PAGE = {
  APS_HOME: ``,
  APS_LIST: `/list`,
  APS_DETAIL: `/detail`
}

export default PAGE
